import { render, staticRenderFns } from "./DifficultyIndicator.vue?vue&type=template&id=1002ec00&scoped=true"
import script from "./DifficultyIndicator.vue?vue&type=script&lang=ts"
export * from "./DifficultyIndicator.vue?vue&type=script&lang=ts"
import style0 from "./DifficultyIndicator.vue?vue&type=style&index=0&id=1002ec00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1002ec00",
  null
  
)

export default component.exports